import { Card, Stack } from "@mantine/core";
import type { ReactNode } from "react";
import { Link } from "react-router";

interface ISSAccountCardProps {
  children: ReactNode;
  header: ReactNode;
  href?: string;
}

const SSAccountCard: React.FC<ISSAccountCardProps> = ({
  children,
  header,
  href,
}) => {
  const props = href ? { component: Link, to: href } : { to: "" };

  return (
    <Card
      withBorder
      classNames={{
        root: "border-primary-light hover-scale relative min-w-[320px] block font-inter",
      }}
      className="bg-[#23252A]"
      radius={15}
      {...props}
    >
      {header}
      <Stack mt={15}>{children}</Stack>
    </Card>
  );
};

export default SSAccountCard;
